import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './styles.css';

const PlanTypeBox = ({ subscriptionType, supportPlan, contactSales }) => (
  <div className="plan-type-box">
    <div className="plan-type-box-column">
      <strong>Subscription Type</strong>
      <p className="plan-type-box__subscription-type">{subscriptionType}</p>
    </div>
    {supportPlan && (
      <div className="plan-type-box-column">
        <strong>Support Plan</strong>
        <p>{supportPlan}</p>
      </div>
    )}
    <div
      className={classNames('plan-type-box-column', {
        'plan-type-box-column--small': !contactSales
      })}
    >
      {contactSales && (
        <button
          className="btn btn-success plan-type-box__contact-sales"
          onClick={contactSales}
        >
          Upgrade your Plan
        </button>
      )}
    </div>
  </div>
);

PlanTypeBox.propTypes = {
  subscriptionType: PropTypes.string,
  supportPlan: PropTypes.string,
  contactSales: PropTypes.func
};

PlanTypeBox.defaultProps = {
  subscriptionType: 'Free'
};

export default PlanTypeBox;
